import { toastInfo, toastSuccess, toastError } from '../utils/toastMessage';
import errorHandler from '../utils/errorHandler';
import { loaderStart, loaderFinish } from './loader';
import API from '../utils/API';
import { getFolders, setAllFolders } from './folders';
import { changeTemplateSameDaysCount } from './templateGenerator';
import { RESET_CHOOSED_TEMPLATE } from '../constants/constants';

export const getTemplatesSuccess = (data) => {
  return {
    type: 'GET_ALL_TEMPLATES_SUCCESS',
    data,
  };
};

export const getTemplatesError = (message) => {
  return {
    type: 'GET_ALL_TEMPLATES_ERROR',
    payload: { message },
  };
};

export const getTemplateSuccess = (data) => {
  return {
    type: 'GET_TEMPLATE_SUCCESS',
    data,
  };
};

export const confirmDeletingTemplate = (id, name) => {
  return {
    type: 'CONFIRM_DELETING_TEMPLATE',
    id,
    name,
  };
};

export const deleteTemplateSuccess = () => {
  return {
    type: 'DELETE_TEMPLATE_SUCCESS',
  };
};

export const deleteTemplateError = () => {
  return {
    type: 'DELETE_TEMPLATE_ERROR',
  };
};

export const cancelDeletingTemplate = () => {
  return {
    type: 'DELETE_TEMPLATE_CANCEL',
  };
};

export const resetChoosedTemplate = () => {
  return {
    type: RESET_CHOOSED_TEMPLATE,
  };
};

export const getTemplate = (id) => {
  return (dispatch) => {
    dispatch(loaderStart());
    API.get(`/template/${id}`)
      .then((response) => {
        // eslint-disable-next-line prefer-template
        dispatch(changeTemplateSameDaysCount('' + response.data.data.numberOfRecurringDays));
        dispatch(loaderFinish());
        dispatch(getTemplateSuccess(response.data.data));
      })
      .catch(function (error) {
        dispatch(getTemplateSuccess(''));
        dispatch(loaderFinish());
        if (error.response && error.response.status === 404) {
          dispatch(getTemplatesError('У шаблона нет данных :('));
        }
        const errorConfig = {
          404: {
            message: 'Данные шаблона не найдены',
          },
        };
        errorHandler(error.response.status, errorConfig);
      });
  };
};

export const filterTemplates = (tags) => {
  const queryStrTagsIds = tags.join('|');
  return (dispatch) => {
    API.get(`/template?template=1&tags=${queryStrTagsIds}&page=&userId=&selectedComplexPeriod=`)
      .then((response) => {
        toastSuccess();
        dispatch(setAllFolders(response.data));
      })
      .catch(() => {
        dispatch(getTemplatesError('Шаблонов с такими тегами не было найдено...'));
        toastInfo('Шаблонов с такими тегами не было найдено...');
      });
  };
};

export const deleteTemplate = (templateId) => {
  return (dispatch) => {
    API.delete(`/template/${templateId}`)
      .then(() => {
        toastSuccess();
        dispatch(deleteTemplateSuccess());
        dispatch(getTemplateSuccess());
        dispatch(getFolders());
      })
      .catch(() => {
        dispatch(deleteTemplateError());
        toastError('В процессе удаления шаблона возникла ошибка');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/template.js